export default {
  id: 98,
  title: 'Target #98 - Candle',
  url: 'https://cssbattle.dev/play/98',
  colors: ['#14313E', '#BA3E46', '#F3695A', '#F3AC3C'],
  solution:
    '<a a><a b><a c><style>[a],[b]{left:160;width:80}body{background:#14313e}a{position:fixed}[a]{top:125;height:115;background:#ba3e46;border-radius:0 0 50px 50px/0 0 18px 18px}[b]{top:110;height:30;background:radial-gradient(30px 15px at 50% 5px,#14313e 35px,#f3695a 35px);border-radius:100%}[c]{top:60;left:200;width:30;height:50;background:#f3ac3c;border-radius:9in 0}</style>',
}
